export const CROSS_SELL_CHARGER_FIELD_NAME = 'addedCrossSellCharger';
export const CHARGER_INPUT_SELECTOR = `input[name="${CROSS_SELL_CHARGER_FIELD_NAME}"]`;
export const MISSING_CHARGER_STORAGE_KEY_PREFIX = 'activateMissingChargerForProductId_';
export const CHARGER_SYNC_EVENT = 'charger-sync';
